export default __webpack_public_path__ + "static/media/jarra nim.2a805193.jpg";